import React from "react";

import { FlexDiv, Image } from "../../Atoms";
import Typography from "../../../foundation/Typography/V2";
import theme from "../../../foundation/Theme";

export const formatOptionLabel = ({ code }) => (
  <FlexDiv alignItems="center">
    <FlexDiv height="16px" width="24px" mr="4px">
      {(code === "+91" ||
        code === "+971" ||
        code === "+974" ||
        code === "+1" ||
        code === "+65" ||
        code === "+44") && (
        <Image
          maxWidth="24px"
          maxHeight="16px"
          imageName={`flags/${
            code === "+91"
              ? "india.png"
              : code === "+971"
              ? "uae.png"
              : code === "+974"
              ? "qatar.png"
              : code === "+1"
              ? "usa.png"
              : code === "+65"
              ? "singapore.png"
              : code === "+44" && "uk.png"
          }`}
          alt="flag"
        />
      )}
    </FlexDiv>
    <Typography
      variant="span"
      fontSize="14px"
      fontFamily="var(--font-400)"
      color={theme.colors.gray_90}
    >
      {code}
    </Typography>
  </FlexDiv>
);
